<template>
  <div>
    <div class="row">
      <div class="col-md-12" v-if="!filters.central_id">
        <div class="alert alert-warning" role="alert">
          <strong>Atenção:</strong> Selecione uma agência para filtrar por
          convênio.
        </div>
      </div>
      <div class="col-md-2 mb-1">
        <label for="flagUnitSelect">Agência:</label>
        <v-select
          v-model="filters.central_id"
          :options="centrals"
          :reduce="(central) => central.id"
          label="fantasy_name"
          multiple
          placeholder="Exibir Todos"
          v-on:input="refreshAllData"
        ></v-select>
      </div>
      <div class="col-md-2">
        <label for="flagUnitSelect">Serviço:</label>
        <v-select
          v-model="filters.occurrence_type"
          :options="[{ value: 'APH', label: 'APH' }]"
          :reduce="(option) => option.value"
          label="label"
          multiple
          placeholder="Exibir APH"
          v-on:input="refreshAllData"
        ></v-select>
      </div>
      <div class="col-md-2 mb-1">
        <label for="flagUnitSelect">Unidades:</label>
        <v-select
          v-model="filters.unit_id"
          :options="units"
          :reduce="(unit) => unit.id"
          label="unit_name"
          multiple
          placeholder="Exibir Todos"
          v-on:input="refreshAllData"
        ></v-select>
      </div>
      <div class="col-md-2">
        <label for="flagUnitSelect">Tipo da Ocorrência:</label>
        <v-select
          v-model="filters.type_id"
          :options="types"
          :reduce="(type) => type.id"
          label="title"
          multiple
          placeholder="Exibir Todos"
        ></v-select>
      </div>
      <div
        class="col-md-2"
        v-if="filters.central_id && filters.central_id.length > 0"
      >
        <label for="flagUnitSelect">Convênio:</label>
        <select
          id="flagUnitSelect"
          class="form-control"
          v-model="filters.health_plan"
        >
          <option :value="null">Exibir Todos</option>
          <option v-for="plan in plans" :key="plan.id" :value="plan.id">
            {{ plan.title }}
          </option>
        </select>
      </div>
      <div class="col-md-2">
        <label>Data Inicial</label>
        <input
          type="date"
          class="form-control"
          v-model="filters.data_inicio"
          :max="filters.data_fim || null"
        />
      </div>
      <div class="col-md-2 mb-1">
        <label>Data Fim</label>
        <input
          type="date"
          class="form-control"
          v-model="filters.data_fim"
          :min="filters.data_inicio || null"
        />
      </div>
      <div class="col-md-2 mb-1 d-flex align-items-end">
        <button class="btn btn-primary btn-block" @click="refreshAllData">
          <feather-icon icon="FilterIcon" class="mr-50" size="16" />
          Filtrar
        </button>
      </div>
      <br />
    </div>
    <div class="row">
      <div class="col-md-6" id="occurrences_progress">
        <router-link to="/occurrences_progress" style="color: #82868b">
          <b-card no-body>
            <b-card-body class="pb-0">
              <b-avatar class="mb-1" :variant="`light-warning`" size="45">
                <feather-icon size="21" :icon="'HeartIcon'" />
              </b-avatar>
              <div class="truncate mb-2">
                <h2 class="mb-25 font-weight-bolder">
                  {{ dashboard.highlights.occurrences_progress }}
                </h2>
                <span>Ocorrências em andamento</span>
              </div>
            </b-card-body>
          </b-card>
        </router-link>
      </div>
      <div class="col-md-6" id="occurrences_finished">
        <router-link
          :to="{
            path: '/occurrences_finished',
            query: {
              data_inicio: filters.data_inicio,
              data_fim: filters.data_fim,
            },
          }"
          style="color: #82868b"
        >
          <b-card no-body>
            <b-card-body class="pb-0">
              <b-avatar class="mb-1" :variant="`light-success`" size="45">
                <feather-icon size="21" :icon="'CheckIcon'" />
              </b-avatar>
              <div class="truncate mb-2">
                <h2 class="mb-25 font-weight-bolder">
                  {{ dashboard.highlights.occurrences_finished }}
                </h2>
                <span>{{ finishedOccurrencesLabel }}</span>
              </div>
            </b-card-body>
          </b-card>
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card p-1">
          <div class="text-center">
            <h6>Total de ocorrências no período</h6>
            <div class="row">
              <div v-if="loading" class="loader">Carregando...</div>
              <div v-else class="chart-container">
                <BarChart
                  :chartData="chartDataFromAPI"
                  :chartOptions="chartOptions"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Gráfico por tipo: uma carta por agência (sem filtro) ou único (com filtro) -->
    <template v-if="chartDataTypeByAgency">
      <div
        v-for="agency in chartDataTypeByAgency"
        :key="agency.id"
        class="row mb-1"
      >
        <div class="col-12">
          <div class="card p-1">
            <div class="text-center">
              <h6>{{ agency.name }} — Tipos de Ocorrência</h6>
              <div class="row">
                <div v-if="loading" class="loader">Carregando...</div>
                <div
                  v-else
                  class="agency-chart"
                  :style="{ height: agency.labels.length * 46 + 40 + 'px' }"
                >
                  <HorizontalBarChart
                    :chart-data="agency.chartData"
                    :chart-options="agencyChartOptions"
                    :height="agency.labels.length * 46 + 40"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-else class="row">
      <div class="col-12">
        <div class="card p-1">
          <div class="text-center">
            <h6>Total de ocorrências por tipo</h6>
            <div class="row">
              <div v-if="loading" class="loader">Carregando...</div>
              <div v-else class="chart-container">
                <HorizontalBarChart
                  :chart-data="chartDataTypeFromAPI"
                  :chart-options="chartTypeOptions"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Gráfico por motivo: uma carta por agência (sem filtro) ou único (com filtro) -->
    <template v-if="chartDataReasonByAgency">
      <div
        v-for="agency in chartDataReasonByAgency"
        :key="agency.id"
        class="row mb-1"
      >
        <div class="col-12">
          <div class="card p-1">
            <div class="text-center">
              <h6>{{ agency.name }} — Motivos de Ocorrência</h6>
              <div class="row">
                <div v-if="loading" class="loader">Carregando...</div>
                <div v-else class="chart-container">
                  <BarChart
                    :chartData="agency.chartData"
                    :chartOptions="chartReasonOptions"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-else class="row">
      <div class="col-12">
        <div class="card p-1">
          <div class="text-center">
            <h6>Total de ocorrências por motivo</h6>
            <div class="row">
              <div v-if="loading" class="loader">Carregando...</div>
              <div v-else class="chart-container">
                <BarChart
                  :chartData="chartDataReasonFromAPI"
                  :chartOptions="chartReasonOptions"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCardText, BLink } from "bootstrap-vue";
import BarChart from "@/components/BarChart.vue";
import HorizontalBarChart from "@/components/HorizontalBarChart.vue";
import { BCard, BCardBody, BAvatar } from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  data() {
    return {
      filters: {
        data_inicio: "",
        data_fim: "",
        central_id: [],
        type_id: [],
        occurrence_type: [],
        unit_id: [],
        health_plan: null,
      },
      units: [],
      interval: "",
      dashboard: {
        highlights: {
          occurrences: 0,
        },
      },
      chartDataFromAPI: {
        labels: [],
        datasets: [
          {
            label: "Ocorrências por mês",
            backgroundColor: [],
            borderWidth: 1,
            data: [],
          },
        ],
      },

      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },

      chartDataTypeFromAPI: {
        labels: [],
        datasets: [
          {
            label: "Tipos",
            backgroundColor: [],
            borderWidth: 1,
            data: [],
          },
        ],
      },
      chartTypeOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{ ticks: { beginAtZero: true } }],
          yAxes: [{ ticks: { autoSkip: false } }],
        },
      },
      chartDataReasonFromAPI: {
        labels: [],
        datasets: [
          {
            label: "Motivos",
            backgroundColor: [],
            borderWidth: 1,
            data: [],
          },
        ],
      },
      chartReasonOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      loading: false,
      centrals: [],
      types: [],
      plans: [],
      chartDataTypeByAgency: null,
      chartDataReasonByAgency: null,
      agencyChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [{ ticks: { beginAtZero: true } }],
          yAxes: [
            {
              ticks: { autoSkip: false },
              // Chart.js v2: estas props vivem no scale, NÃO no dataset
              categoryPercentage: 0.8,
              barPercentage: 0.9,
            },
          ],
        },
      },
    };
  },
  components: {
    BCard,
    BCardText,
    BLink,
    BCard,
    BCardBody,
    BAvatar,
    BarChart,
    HorizontalBarChart,
    vSelect,
  },
  computed: {
    finishedOccurrencesLabel() {
      if (this.dashboard.highlights.has_date_filter) {
        const start = this.dashboard.highlights.date_start;
        const end = this.dashboard.highlights.date_end;
        if (start === end) {
          return `Ocorrências Finalizadas no dia ${start}`;
        } else {
          return `Ocorrências Finalizadas de ${start} a ${end}`;
        }
      }
      return "Ocorrências Finalizadas nas últimas 24h";
    },
  },
  methods: {
    getDashboard() {
      const self = this;

      const params = {
        data_inicio: self.filters.data_inicio,
        data_fim: self.filters.data_fim
          ? self.filters.data_fim + " 23:59:59"
          : null,
        central_id:
          self.filters.central_id !== null ? self.filters.central_id : null,
        type_id: self.filters.type_id !== null ? self.filters.type_id : null,
        unit_id: self.filters.unit_id !== null ? self.filters.unit_id : null,

        occurrence_type:
          self.filters.occurrence_type !== null
            ? self.filters.occurrence_type
            : null,

        health_plan:
          self.filters.health_plan !== null ? self.filters.health_plan : null,
      };

      axios
        .post(this.$store.state.api + "dashboard", {}, { params })
        .then((response) => {
          self.dashboard = response.data;
        })
        .catch((error) => {
          self.$message(
            null,
            error.response?.data || "Erro inesperado",
            "error"
          );
        });
    },
    getGraphicOccurrences() {
      const self = this;

      const params = {
        data_inicio: self.filters.data_inicio,
        data_fim: self.filters.data_fim
          ? self.filters.data_fim + " 23:59:59"
          : null,
        central_id:
          self.filters.central_id !== null ? self.filters.central_id : null,
        type_id: self.filters.type_id !== null ? self.filters.type_id : null,
        occurrence_type:
          self.filters.occurrence_type !== null
            ? self.filters.occurrence_type
            : null,
        unit_id: self.filters.unit_id !== null ? self.filters.unit_id : null,
        health_plan:
          self.filters.health_plan !== null ? self.filters.health_plan : null,
      };

      const colors = [
        "rgba(114, 159, 207, 0.4)", // Azul médio
        "rgba(54, 162, 235, 0.4)", // Azul claro
        "rgba(255, 206, 86, 0.4)", // Amarelo claro
        "rgba(75, 192, 192, 0.4)", // Ciano claro
        "rgba(153, 102, 255, 0.4)", // Roxo claro
        "rgba(255, 159, 64, 0.4)", // Laranja claro
        "rgba(201, 203, 207, 0.4)", // Cinza claro
        "rgba(138, 226, 52, 0.4)", // Verde-limão
        "rgba(245, 121, 0, 0.4)", // Laranja escuro
        "rgba(173, 127, 168, 0.4)", // Lavanda
        "rgba(255, 99, 132, 0.4)", // Vermelho claro
        "rgba(233, 185, 110, 0.4)", // Bege
      ];

      self.$loading(true);
      self.loading = true;

      axios
        .get(this.$store.state.api + "graphic_occurrences", { params })
        .then((response) => {
          const occurrences = response.data;

          self.chartDataFromAPI.labels = occurrences.labels;
          self.chartDataFromAPI.datasets[0].data = occurrences.data;

          self.chartDataFromAPI.datasets[0].backgroundColor =
            occurrences.labels.map((_, index) => colors[index % colors.length]);

          self.loading = false;
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(
            null,
            error.response?.data || "Erro inesperado",
            "error"
          );
          self.$loading(false);
          self.loading = false;
        });
    },

    getGraphicTypeOccurrences() {
      const params = {
        data_inicio: this.filters.data_inicio,
        data_fim: this.filters.data_fim
          ? this.filters.data_fim + " 23:59:59"
          : null,
        central_id: this.filters.central_id,
        type_id: this.filters.type_id,
        occurrence_type: this.filters.occurrence_type,
        unit_id: this.filters.unit_id,
        health_plan: this.filters.health_plan,
      };

      const colors = [
        "rgba(114, 159, 207, 0.4)", // Azul médio
        "rgba(54, 162, 235, 0.4)", // Azul claro
        "rgba(255, 206, 86, 0.4)", // Amarelo claro
        "rgba(75, 192, 192, 0.4)", // Ciano claro
        "rgba(153, 102, 255, 0.4)", // Roxo claro
        "rgba(255, 159, 64, 0.4)", // Laranja claro
        "rgba(201, 203, 207, 0.4)", // Cinza claro
        "rgba(138, 226, 52, 0.4)", // Verde-limão
        "rgba(245, 121, 0, 0.4)", // Laranja escuro
        "rgba(173, 127, 168, 0.4)", // Lavanda
        "rgba(255, 99, 132, 0.4)", // Vermelho claro
        "rgba(233, 185, 110, 0.4)", // Bege
      ];

      this.$loading(true);
      this.loading = true;

      axios
        .get(this.$store.state.api + "graphic_occurrences_type", { params })
        .then((response) => {
          const occurrences = response.data;

          if (occurrences.by_agency) {
            this.chartDataTypeByAgency = occurrences.agencies.map((agency) => ({
              id: agency.id,
              name: agency.name,
              labels: agency.labels,
              chartData: {
                labels: agency.labels,
                datasets: [
                  {
                    label: "Tipos",
                    data: agency.data,
                    backgroundColor: agency.labels.map(
                      (_, index) => colors[index % colors.length]
                    ),
                    borderWidth: 1,
                    maxBarThickness: 34,
                  },
                ],
              },
            }));
            this.chartDataTypeFromAPI = {
              labels: [],
              datasets: [
                {
                  label: "Tipos",
                  backgroundColor: [],
                  borderWidth: 1,
                  data: [],
                },
              ],
            };
          } else {
            this.chartDataTypeByAgency = null;
            this.chartDataTypeFromAPI = {
              labels: occurrences.labels,
              datasets: [
                {
                  label: "Tipos",
                  data: occurrences.data,
                  backgroundColor: occurrences.labels.map(
                    (_, index) => colors[index % colors.length]
                  ),
                  borderWidth: 1,
                  barThickness: 26,
                },
              ],
            };
          }

          this.loading = false;
          this.$loading(false);
        })
        .catch((error) => {
          this.$message(
            null,
            error.response?.data || "Erro inesperado",
            "error"
          );
          this.$loading(false);
          this.loading = false;
        });
    },

    getGraphicReasonOccurrences() {
      const self = this;

      const params = {
        data_inicio: self.filters.data_inicio,
        data_fim: self.filters.data_fim
          ? self.filters.data_fim + " 23:59:59"
          : null,
        central_id:
          self.filters.central_id !== null ? self.filters.central_id : null,
        type_id: self.filters.type_id !== null ? self.filters.type_id : null,
        occurrence_type:
          self.filters.occurrence_type !== null
            ? self.filters.occurrence_type
            : null,
        unit_id: self.filters.unit_id !== null ? self.filters.unit_id : null,
        health_plan:
          self.filters.health_plan !== null ? self.filters.health_plan : null,
      };

      const colors = [
        "rgba(114, 159, 207, 0.4)", // Azul médio
        "rgba(54, 162, 235, 0.4)", // Azul claro
        "rgba(255, 206, 86, 0.4)", // Amarelo claro
        "rgba(75, 192, 192, 0.4)", // Ciano claro
        "rgba(153, 102, 255, 0.4)", // Roxo claro
        "rgba(255, 159, 64, 0.4)", // Laranja claro
        "rgba(201, 203, 207, 0.4)", // Cinza claro
        "rgba(138, 226, 52, 0.4)", // Verde-limão
        "rgba(245, 121, 0, 0.4)", // Laranja escuro
        "rgba(173, 127, 168, 0.4)", // Lavanda
        "rgba(255, 99, 132, 0.4)", // Vermelho claro
        "rgba(233, 185, 110, 0.4)", // Bege
      ];

      self.$loading(true);
      self.loading = true;

      axios
        .get(this.$store.state.api + "graphic_occurrences_reason", { params })
        .then((response) => {
          const occurrences = response.data;

          if (occurrences.by_agency) {
            self.chartDataReasonByAgency = occurrences.agencies.map(
              (agency) => ({
                id: agency.id,
                name: agency.name,
                labels: agency.labels,
                chartData: {
                  labels: agency.labels,
                  datasets: [
                    {
                      label: "Motivos",
                      data: agency.data,
                      backgroundColor: agency.labels.map(
                        (_, index) => colors[index % colors.length]
                      ),
                      borderWidth: 1,
                    },
                  ],
                },
              })
            );
          } else {
            self.chartDataReasonByAgency = null;
            self.chartDataReasonFromAPI = {
              labels: occurrences.labels,
              datasets: [
                {
                  label: "Motivos",
                  data: occurrences.data,
                  backgroundColor: occurrences.labels.map(
                    (_, index) => colors[index % colors.length]
                  ),
                  borderWidth: 1,
                },
              ],
            };
          }

          self.loading = false;
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(
            null,
            error.response?.data || "Erro inesperado",
            "error"
          );
          self.$loading(false);
          self.loading = false;
        });
    },

    getCentrals: function () {
      const self = this;
      const api = self.$store.state.api + "centrals?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.centrals = response.data.data.sort((a, b) =>
            a.fantasy_name.localeCompare(b.fantasy_name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getUnits: function () {
      const self = this;
      let api = self.$store.state.api + "units/filter-by-central";

      if (self.filters.central_id) {
        api += `?central_ids=${self.filters.central_id}`;
      }

      axios
        .get(api)
        .then((response) => {
          self.units = response.data.data.sort((a, b) =>
            a.unit_name.localeCompare(b.unit_name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getTypes: function () {
      const self = this;
      let api = self.$store.state.api + "types?paginated=false";

      if (self.filters.central_id && self.filters.central_id.length > 0) {
        api += `&central_id=${self.filters.central_id}`;
      }

      axios
        .get(api)
        .then((response) => {
          self.types = response.data.data.sort((a, b) =>
            a.title.localeCompare(b.title)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getMedicals: function () {
      const self = this;
      let api = self.$store.state.api + "medical-agreements?paginated=false";

      if (self.filters.central_id && self.filters.central_id.length > 0) {
        api += `&central_id=${self.filters.central_id}`;
      }

      axios
        .get(api)
        .then((response) => {
          // Filtrar duplicatas por title (exibir apenas o primeiro de cada)
          const uniquePlans = response.data.data.filter(
            (plan, index, self) =>
              index === self.findIndex((p) => p.title === plan.title)
          );
          self.plans = uniquePlans.sort((a, b) =>
            a.title.localeCompare(b.title)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    // Bloqueia a carga quando a Data Fim é anterior à Data Inicial.
    // (datas do <input type="date"> vêm como 'YYYY-MM-DD' -> comparação de string)
    datesValid() {
      const ini = this.filters.data_inicio;
      const fim = this.filters.data_fim;
      if (ini && fim && fim < ini) {
        swal(
          "Datas inválidas",
          "A Data Final deve ser maior ou igual à Data Inicial.",
          "warning"
        );
        return false;
      }
      return true;
    },
    refreshAllData() {
      if (!this.datesValid()) return;
      this.getGraphicOccurrences();
      this.getDashboard();
      this.getGraphicTypeOccurrences();
      this.getGraphicReasonOccurrences();
      this.getUnits();
      this.getTypes();
      this.getMedicals();
    },
  },
  destroyed() {
    clearInterval(this.interval);
    console.log("destroyed");
  },
  mounted() {
    const self = this;

    let intervl = 0;

    self.refreshAllData();
    self.getCentrals();
    self.getTypes();
    self.getUnits();
    self.getMedicals();

    setTimeout(function () {
      while (intervl < 1000) {
        clearInterval(intervl);
        console.log("limpando intervals");
        intervl++;
      }
    }, 1000);

    // Echo.private("user.1").listen(".Alert", (data) => {
    //   console.log(data);
    // });
  },
  created() {},
};
</script>

<style>
.chart-container {
  width: 100% !important;
  max-width: 100% !important;
  height: 400px;
  margin: 0 auto;
}

.agency-chart {
  position: relative;
  width: 100%;
  margin: 0 auto;
}

h6 {
  color: #4e73df !important;
  font-weight: bold !important;
}
</style>
